import script from "./topics-table-view.vue?vue&type=script&setup=true&lang=js"
export * from "./topics-table-view.vue?vue&type=script&setup=true&lang=js"

import "./topics-table-view.vue?vue&type=style&index=0&id=51c66bb6&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c66bb6"]])

export default __exports__